"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.testAddress = {
    addressLine1: 'string',
    city: 'string',
    state: 'string',
    zipCode: 'string',
    country: 'string',
};
//# sourceMappingURL=index.js.map